const DURATION = 10;

// Round photos rising from the base of the candle upward. Renders nothing when empty.
export const RisingPhotos = ({ items, contained }) => {
  if (!items || !items.length) return null;
  return (
    <div className={`rising-memories${contained ? " rising-memories--contained" : ""}`} data-testid="rising-photos" aria-hidden="true">
      {items.map((it, i) => {
        const delay = -((i * DURATION) / items.length).toFixed(2);
        const isLeft = i % 2 === 0;
        const tier = Math.floor(i / 2) % 3;
        const startX = isLeft ? 30 - tier * 8 : 70 + tier * 8;
        const drift = (isLeft ? -1 : 1) * (12 + tier * 6);
        return (
          <figure
            key={it.key}
            className="rising-memory"
            style={{ left: `${startX}%`, animationDelay: `${delay}s`, animationDuration: `${DURATION}s`, "--drift": `${drift}px` }}
          >
            <svg className="rm-svg" viewBox="0 0 100 100">
              <defs>
                <clipPath id={`rp-clip-${i}`}><circle cx="50" cy="44" r="33" /></clipPath>
                <path id={`rp-arc-${i}`} d="M 14.8 73.6 A 46 46 0 0 0 85.2 73.6" fill="none" />
              </defs>
              <image href={it.url} x="17" y="11" width="66" height="66" clipPath={`url(#rp-clip-${i})`} preserveAspectRatio="xMidYMid slice" />
              <circle cx="50" cy="44" r="33" fill="none" stroke="rgba(212,175,55,0.9)" strokeWidth="2.5" />
              {it.label ? (
                <text className="rm-arc-text">
                  <textPath href={`#rp-arc-${i}`} startOffset="50%" textAnchor="middle">{it.label}</textPath>
                </text>
              ) : null}
            </svg>
          </figure>
        );
      })}
    </div>
  );
};
